import { useQuery } from '@tanstack/react-query';
import http from 'helpers/requests';

export const useFetchDeclarant = ({ enabled = true } = {}) => {
  return useQuery({
    queryKey: ['declarant'],
    queryFn: async () => {
      const response = await http.get('/declarant');
      return response.data.declarant;
    },
    // Callers mounted for non-declarant org types (e.g. NavSidebar) pass
    // enabled: false so we never fire GET /declarant for operators.
    enabled,
    // Backs an editable form. Refetching on window focus replaces the record
    // reference mid-edit, which churns the form's derived defaults — leave it
    // off so switching tabs never disturbs in-progress input.
    refetchOnWindowFocus: false,
  });
};
